/** All possible values for font weights */
export var fontWeight = {
    light: 300,
    normal: 400,
    semiBold: 600,
    bold: 700
};
//# sourceMappingURL=fontWeight.js.map